<template>
    <div class="report-builder flex w-10/12 bg-gray-400 pl-4 rounded">

      <div class="w-full sm:mb-0 sm:w-2/3 md:border-r-8 md:border-gray-200 pr-4 pb-4" style="max-height: 750px; overflow-y: scroll">
          <h4>Included Activities</h4>
            <draggable :list="usedactivities" animation="100" group="buildWizardTemplate" tag="ul" @change="update" class="buildreport-side-a">
              <li v-for="(activity, index) in usedactivities" class="listbox flex mb-1">
                <div class="flex items-center inline-block w-6 justify-center bg-gray-200 flex-none cursor-move">{{ index + 1 }}</div>
                <span class="flex-grow align-middle cursor-move">
                  <div class="block relative">
                    <div class="absolute right-0">
                      <a class="text-xxs" :href="'/demowizardactivity/'+activity.id+''" target="_blank">Preview<i aria-hidden="true" class="material-icons align-middle text-sm ml-1">open_in_new</i></a>
                    </div>
                    <span class="inline-block text-xxs leading-tight mr-2 text-orange-700">
                        {{ activity.wizard_activity_type.name }} 
                    </span>
                  </div>
                  <h4 class="mt-0 pt-0 text-xs">{{ activity.name }}</h4>
                  <div class="block text-xxs leading-tight">
                      {{ activity.short_desc }}
                  </div>
                  <div class="block">
                    <span v-if="activity.authors" v-for="authors in activity.authors" class="inline-block text-xxs leading-tight mr-2 text-green-700">
                        {{ authors.first_name }} {{ authors.last_name }}
                    </span>
                    <span v-if="activity.psych_model" class="block text-xxs leading-tight mr-2 bg-yellow-200 p-1">
                            {{ activity.psych_model.name }} 
                    </span>
                  </div>
                </span>
                  <div class="handle cursor-move flex items-center inline-block w-8 justify-center bg-gray-200 flex-none"><i aria-hidden="true" class="material-icons text-lg text-indigo-500">open_with</i></div>
              </li>
            </draggable>
      </div>

      <div class="w-full sm:mb-0 sm:w-1/2 px-4" style="max-height: 750px; overflow-y: scroll">
          <h4>Available Activities</h4>

          <!-- Demo of filtering report list -->
          <input type="text" v-model="filter" class="w-full text-sm mb-4 mt-2" placeholder="Search By Title">

            <draggable :list="unusedactivities" class="buildreport-side-b" animation="100" group="buildWizardTemplate" tag="ul" handle=".handle">
              <li v-for="(activity, index) in unusedactivities" :key="activity.id" class="mb-0">
                <div v-if="isInFilteredActivities(activity)" class="listbox flex mb-1">
                  <div class="handle cursor-move flex items-center inline-block w-5 justify-center bg-gray-100 bg-gray-300"><i aria-hidden="true" class="material-icons text-sm text-indigo-500">open_with</i></div>

                  <span class="flex-grow align-middle">
                      <div class="block relative">
                        <div class="absolute right-0">
                          <a class="text-xxs" :href="'/demowizardactivity/'+activity.id+''" target="_blank">Preview<i aria-hidden="true" class="material-icons align-middle text-sm ml-1">open_in_new</i></a>
                        </div>
                        <span class="inline-block text-xxs leading-tight mr-2 text-orange-700">
                            {{ activity.wizard_activity_type.name }} 
                        </span>
                      </div>
                      <h4 class="mt-0 pt-0 text-xs">{{ activity.name }}</h4>
                      <div class="block text-xxs leading-tight">
                          {{ activity.short_desc }}
                      </div>
                      <div class="block">
                        <span v-if="activity.authors" v-for="authors in activity.authors" class="inline-block text-xxs leading-tight mr-2 text-green-700">
                            {{ authors.first_name }} {{ authors.last_name }}
                        </span>
                        <span v-if="activity.psych_model" class="block text-xxs leading-tight mr-2 bg-yellow-200 p-1">
                            {{ activity.psych_model.name }} 
                        </span>
                      </div>
                      <span v-if="activity.internal_notes" class="absolute right-0 top-0 inline-block w-2 h-2 bg-yellow-300"></span>
                    </span>
                  </span>

                  </div>
              </li>
            </draggable>
      </div>

    </div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'
import draggable from 'vuedraggable'

  export default {
    display: "Two Lists",
    order: 1,
      components: {
        draggable,
      },
        props: {
            wizardactivities: '',
            allactivities: '',
            route:'',
        },
        data() {
          return {
            usedactivities: this.wizardactivities,
            unusedactivities: this.allactivities,
            filter: '',
          }
        },
        computed: {
            filteredActivities() {
              return this.filter
                ? this.unusedactivities.filter(activity => {
                  return activity.name.toLowerCase().includes(this.filter.toLowerCase()) || 
                  activity.psych_model.name.toLowerCase().includes(this.filter.toLowerCase()) || 
                  activity.wizard_activity_type.name.toLowerCase().includes(this.filter.toLowerCase()) ||
                  activity.authors.some(author => {
                    return author.first_name.toLowerCase().includes(this.filter.toLowerCase()) ||
                    author.last_name.toLowerCase().includes(this.filter.toLowerCase());
                  });
                })
                : this.unusedactivities;
            },
        },
        methods: {
          isInFilteredActivities(activity) {
            return this.filteredActivities.includes(activity);
          },
          update() {

            axios.put(this.route,
                { id: this.wizardactivities.map(dataSet => dataSet.id) }
              )
              .then(function (response) {
                  console.log('updating');
                })

          }

        },

      };
</script>
